export enum AnalyticalComponents {
  MAIN_DASHBOARD_CHART = 'main-dashboard-chart',
  REVENUE_GOAL = 'revenue-goal',
  CUSTOMER_GOAL = 'customer-goal',
  RECEIPT_GOAL = 'receipt-goal'
}
